import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { ParamHandlingService } from '@services/misc-services/param-handling.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { OktaAuthService } from '@services/_iam/okta-auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
    private acmicService: AcmicService,
    private paramHandlingService: ParamHandlingService,
    private oktaAuthService: OktaAuthService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth) { }


  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    void state;
    // If Okta is currently processing a login redirect (token exchange in progress),
    // block navigation here and do NOT trigger another signInWithRedirect — this prevents the loop.
    // if (await this.oktaAuth.isLoginRedirect()) {
    //   return false;
    // }

    if (localStorage.getItem('currentUser')) {
      return true;
    }

    const queryParams = route.queryParams;

    if (this.acmicService.isACMIC()) {
      this.paramHandlingService.addQueryParamToObj('utm_source', queryParams['utm_source']);
      this.paramHandlingService.addQueryParamToObj('utm_medium', queryParams['utm_medium']);
      this.paramHandlingService.addQueryParamToObj('utm_campaign', queryParams['utm_campaign']);
    }

    const utmParams = this.paramHandlingService.getUtmQueryParams();

    // Redirect to Okta login with original URI.
    // Uses the guarded wrapper (not this.oktaAuth directly) so concurrent
    // canActivate invocations (e.g. multiple guarded child routes resolving
    // at once) don't each regenerate/overwrite the PKCE codeVerifier in
    // storage, which causes AuthSdkError on the /login/callback.
    await this.oktaAuthService.signInWithRedirect({
      originalUri: "/home",
      extraParams: utmParams
    });

    return false;
  }
}